// config.js

const CONFIG = {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'https://api.qa.cultivio.com',
};

export default CONFIG;
